module.exports = __webpack_public_path__ + "img/help_home_small.5b7818c5.png";